'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPersonStalker = function IoPersonStalker(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.7 25.4c3.3 1.2 4.1 2 4.1 2.6 0.2 0.7 0.2 7 0.2 7h-7.7c0-1.4 0-5.5 0-6-0.1-0.8-0.1-2.3-4.3-3.9-0.7-0.3-1.1-0.4-1.5-0.6 1.4-0.6 1.2-1.1 1.2-2.2 0-1.4-0.7-0.8-1.2-3.6-0.2-1.1-0.3-0.4-0.7-2.2-0.3-1 0.1-1 0.1-1.4s-0.1-0.8-0.2-1.7c-0.1-1.1 0.9-4.1 4.5-4.1s4.6 3 4.5 4.1c-0.1 0.9-0.2 1.2-0.2 1.7 0 0.4 0.3 0.4 0.1 1.4-0.4 1.8-0.5 1.1-0.7 2.2-0.5 2.8-1.2 2.2-1.2 3.6 0 2.3-0.2 1.8 3 3.1z m-5.3 9.6h-25.4s0-5.1 0.2-6c0.1-0.8 1.1-1.7 5.3-3.4 4.3-1.5 4-1.3 4-4.3 0-1.8-1-0.6-1.6-4.2-0.2-1.4-0.4-0.5-0.9-2.8-0.2-1.2 0.2-1.3 0.1-1.8s-0.1-1.1-0.2-2.3c-0.2-1.4 1.1-5.2 5.8-5.2s6 3.8 5.8 5.2c-0.1 1.2-0.1 1.8-0.2 2.3s0.4 0.6 0.1 1.8c-0.4 2.3-0.7 1.4-0.9 2.8-0.6 3.6-1.6 2.4-1.6 4.2 0 2.5-0.1 2.8 2.5 3.8 0.4 0.1 0.8 0.3 1.4 0.5 4.3 1.7 5.3 2.6 5.4 3.4 0.1 0.5 0.2 2.2 0.2 3.7v2.3z' })
        )
    );
};

exports.default = IoPersonStalker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/person-stalker.js
// module id = 2857
// module chunks = 168707334958949